var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-child"},[(_vm.campaign.content_alt && _vm.campaign.content_alt.content.length > 0)?_c('Content',{staticClass:"campaign-content",attrs:{"content":_vm.campaign.content_alt.content}}):_c('div',{staticClass:"campaign-content",domProps:{"innerHTML":_vm._s(_vm.campaign.content.rendered)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }